import React from 'react';
// import { HistoryData, Info, ActivityData } from '../';

export const BackSwitchComponents = (props) => {
  const currentTab = props.currentTab;
  const openlight1 = true;
  const openlight2 = true;
  const openlight3 = true;

  const imagesPath = {
    open: '/assets/images/devices/icon-light-open.png',
    close: '/assets/images/devices/icon-light-close.png',
  };

  function onClick1() {}
  function onClick2() {}
  function onClick3() {}
  return (
    <>
      {props.menu}
      {/* Control tab */}
      {currentTab === 'control' && (
        <div className="iot-element" id="iot-control-light2">
          <div className="columns">
            <div
              className="column"
              style={{
                // border: '1px #aaa solid',
                borderRadius: '5px',
                margin: '5px',
              }}
            >
              <div
                className="column"
                style={{
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                Window Switch
              </div>
              <div className="column">
                <img
                  alt="back-switch-3"
                  id="icon-light-close3"
                  style={{
                    width: '100px',
                    height: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '17%',
                    cursor: 'pointer',
                  }}
                  src={openlight1 ? imagesPath.open : imagesPath.close}
                  onClick={onClick1}
                />
                <hr />
              </div>
              <div className="column">
                <button
                  className={
                    // status.window_switch.status === 'on'
                    openlight1
                      ? 'button is-success device-controller'
                      : 'button is-unsuccess device-controller'
                  }
                  style={{
                    width: '100px',
                    height: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                  onClick={onClick1}
                >
                  {/* {status.window_switch.status === 'on' ? 'ON' : 'OFF'} */}
                  {openlight1 ? 'ON' : 'OFF'}
                </button>
              </div>
            </div>
            <div
              className="column"
              style={{
                // border: '1px #aaa solid',
                borderRadius: '5px',
                margin: '5px',
              }}
            >
              <div
                className="column"
                style={{
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                Wardrobe Switch
              </div>
              <div className="column">
                <img
                  alt="back-switch-4"
                  id="icon-light-close4"
                  style={{
                    width: '100px',
                    height: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '17%',
                    cursor: 'pointer',
                  }}
                  src={openlight2 ? imagesPath.open : imagesPath.close}
                  onClick={onClick2}
                />
                <hr />
              </div>
              <div className="column">
                <button
                  className={
                    // status.wardrobe_switch.status === 'on'
                    openlight2
                      ? 'button is-success device-controller'
                      : 'button is-unsuccess device-controller'
                  }
                  style={{
                    width: '100px',
                    height: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                  onClick={onClick2}
                >
                  {/* {status.wardrobe_switch.status === 'on' ? 'ON' : 'OFF'} */}
                  {openlight2 ? 'ON' : 'OFF'}
                </button>
              </div>
            </div>
            <div
              className="column"
              style={{
                // border: '1px #aaa solid',
                borderRadius: '5px',
                margin: '5px',
              }}
            >
              <div
                className="column"
                style={{
                  fontWeight: 'bold',
                  textAlign: 'center',
                }}
              >
                Bed Switch
              </div>
              <div className="column">
                <img
                  alt="back-switch5"
                  id="icon-light-close5"
                  style={{
                    width: '100px',
                    height: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '17%',
                    cursor: 'pointer',
                  }}
                  src={openlight3 ? imagesPath.open : imagesPath.close}
                  onClick={onClick3}
                />
                <hr />
              </div>
              <div className="column">
                <button
                  className={
                    // status.bed_switch.status === 'on'
                    openlight3
                      ? 'button is-success device-controller'
                      : 'button is-unsuccess device-controller'
                  }
                  style={{
                    width: '100px',
                    height: 'auto',
                    display: 'block',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                  }}
                  onClick={onClick3}
                >
                  {/* {status.bed_switch.status === 'on' ? 'ON' : 'OFF'} */}
                  {openlight3 ? 'ON' : 'OFF'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {currentTab === 'info' && <>INFO</>}
      {currentTab === 'activity' && <>ACTIVITY</>}
      {currentTab === 'history' && <>HISTORY</>}

      {/* {currentTab === 'info' && (
        <Info image={image_link} header={props.header} detail={props.detail} />
      )}
      {currentTab === 'activity' && <ActivityData onClick={onchildClickActivity} />}
      {currentTab === 'history' && (
        <HistoryData
          data={hist_plot}
          onClick={onchildClickActivity}
          startDate={props.startDate}
          stopDate={props.stopDate}
          handleStartDate={props.handleStartDate}
          handleStopDate={props.handleStopDate}
        />
      )} */}
    </>
  );
};
